module.exports = __webpack_public_path__ + "static/img/Jack-Steele.a900dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Steele.jpg
// module id = Duk7
// module chunks = 0